module.exports = __webpack_public_path__ + "3889049d083f951538e73e59282f8a25.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/news/img1_3.jpg
// module id = 461
// module chunks = 0